import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';
import { useBrowser } from '../contexts/BrowserContext';

interface ShareButtonProps {
  title: string;
  path: string;
  result?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ title, path, result }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const { location } = useBrowser();

  const shareData = {
    title: `${title} | Marine Calculators`,
    text: result ? `${title}\n${result}` : title,
    url: `${location.origin}${path}`
  };

  const handleShare = async () => {
    if (typeof window === 'undefined') return;

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback to copy to clipboard
        const shareText = `${shareData.title}\n${shareData.url}${result ? `\n\nResults:\n${result}` : ''}`;
        await navigator.clipboard.writeText(shareText);
        setCopied(true);
        setShowTooltip(true);
        setTimeout(() => {
          setCopied(false);
          setShowTooltip(false);
        }, 2000);
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleShare}
        className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors"
        title="Share calculator"
      >
        {copied ? (
          <Check className="h-5 w-5" />
        ) : (
          <Share2 className="h-5 w-5" />
        )}
      </button>
      {showTooltip && (
        <div className="absolute right-0 top-full mt-2 px-3 py-1 bg-gray-800 text-white text-sm rounded shadow-lg whitespace-nowrap">
          Copied to clipboard!
        </div>
      )}
    </div>
  );
};

export default ShareButton;